import "./chunk-BG6MEPCE.js";

// src/breadcrumb.tsx
import { useMemo } from "react";
function useBreadcrumb(url, tree) {
  return useMemo(() => getBreadcrumbItems(url, tree), [tree, url]);
}
function getBreadcrumbItems(url, tree) {
  var _a;
  return (_a = searchPath(tree.children, url)) != null ? _a : [];
}
function searchPath(nodes, url) {
  var _a, _b;
  for (const node of nodes) {
    if (node.type === "folder") {
      if (node.index && node.index.url === url) {
        return [
          {
            name: node.index.name,
            url: node.index.url
          }
        ];
      }
      const items = searchPath(node.children, url);
      if (items !== null) {
        items.unshift({
          name: node.name,
          url: (_b = (_a = node.index) == null ? void 0 : _a.url) != null ? _b : null
        });
        return items;
      }
    }
    if (node.type === "page" && node.url === url) {
      return [
        {
          name: node.name,
          url: node.url
        }
      ];
    }
  }
  return null;
}
export {
  getBreadcrumbItems,
  useBreadcrumb
};
